<style lang="less">
@import "../less/common.less";
#stockDetailAccountID {
  .el-dialog__wrapper.exportDialog {
    .el-dialog {
      max-width: 300px;
      border-radius: 4px;

      .el-dialog__body {
        .exportProgress {
          width: 180px;
          margin: auto;
        }
        p {
          width: 100%;
          text-align: center;
        }
      }
    }
  }
  .el-dialog {
    min-width: 1100px;
    max-width: 1100px;
  }
  .el-dialog__header {
    text-align: center;
  }
  .el-dialog__body {
    padding: 12px 30px;
    .productHeader {
      border-bottom: 1px solid #efefef;
      .el-row .el-col {
        display: flex;
        align-items: center;
        .type-flag {
          margin-right: 10px;
          flex: 1;
          text-align: left;
          margin-bottom: 10px !important;
        }
        .export {
          margin-right: 15px;
          margin-bottom: 10px !important;
        }

        .type-show .el-radio {
          margin-right: 15px;
          margin-bottom: 10px !important;
        }
      }
    }
    .showType {
      visibility: hidden;
      height: 0px !important;
      max-height: 0px !important;
      min-height: 0px !important;
      padding: 0px !important;
      margin-bottom: 0px !important;
    }
    .productBodys {
      padding: 6px 10px;
      height: 450px;
      max-height: 450px;
      min-height: 280px;
      .happy-scroll-container {
        width: 98% !important;
        height: 100% !important;
        .el-row {
          margin: 0px !important;
          > .el-col {
            display: flex;
            padding-top: 70px;
            position: relative;
            padding-bottom: 20px;
            border-bottom: 1px solid #efefef;
            text-align: center;
            // > span {
            //   margin: auto;
            // }
            > p {
              position: absolute;
              width: 100%;
              text-align: center;
              top: 10px;
              font-size: 16px;
              font-weight: 600;
            }
            .chart-img-des {
              position: absolute;
              top: 115px;
              width: 70px;
              left: 45px;
              font-size: 14px;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            }
            .chart-txt {
              > div {
                display: flex;
                align-items: center;
                font-size: 13px;
                margin-bottom: 1px;
              }

              .color-block1 {
                color: #f1bc4c;

                > div {
                  background-color: #f1bc4c;
                  width: 10px;
                  height: 10px;
                  margin-right: 8px;
                }
              }

              .color-block2 {
                color: #4e9bed;

                > div {
                  background-color: #4e9bed;
                  width: 10px;
                  height: 10px;
                  margin-right: 8px;
                }
              }

              > div:nth-child(4) {
                margin-top: 8px;
                margin-bottom: 0px;
              }
            }
          }
        }
        .data-more {
          padding: 4px !important;
          > span {
            margin: auto;
            padding: 40px 0 400px;
          }
        }
        .data-more-up,
        .data-more-down {
          padding: 4px !important;
          > span {
            margin: auto;
            padding: 0px;
            font-size: 12px;
          }
        }
      }
    }
    .productBody {
      padding: 6px 10px;
      height: 80%;
      max-height: 500px;
      min-height: 280px;
      overflow: hidden;
      overflow-y: auto;
      > .el-col {
        display: flex;
        padding-top: 60px;
        position: relative;
        padding-bottom: 20px;
        border-bottom: 1px solid #efefef;
        > p {
          position: absolute;
          width: 100%;
          text-align: center;
          top: 6px;
          font-size: 14px;
          font-weight: 600;
        }
        .chart-txt {
          > div {
            display: flex;
            align-items: center;
            font-size: 13px;
            margin-bottom: 1px;
          }

          .color-block1 {
            color: #f1bc4c;

            > div {
              background-color: #f1bc4c;
              width: 10px;
              height: 10px;
              margin-right: 8px;
            }
          }

          .color-block2 {
            color: #4e9bed;

            > div {
              background-color: #4e9bed;
              width: 10px;
              height: 10px;
              margin-right: 8px;
            }
          }

          > div:nth-child(4) {
            margin-bottom: 10px;
          }
        }
      }
      .el-pagination {
        text-align: right;
        margin-top: 10px;
      }
      .el-pagination.is-background .el-pager li:not(.disabled).active {
        visibility: visible;
        height: auto !important;
      }
      // .data-more {
      //   padding: 4px !important;
      //   > span {
      //     cursor: pointer;
      //     margin: auto;
      //     padding: 0 20px;
      //   }
      //   .el-loading-mask {
      //     .el-loading-spinner {
      //       margin-top: -10px;
      //     }
      //   }
      // }
    }
    .dialog-footer {
      border-top: 1px solid #efefef;
      padding-top: 16px;
      text-align: center;
    }
  }
}
</style>

<template>
  <el-dialog id="stockDetailAccountID"
             class="stockDetail"
             :title="deptName+'剩余明细详情'"
             :visible.sync="stockDADialogVisible"
             width="70%"
             :close-on-click-modal="false"
             :close-on-press-escape="false"
             :modal-append-to-body="false"
             :show-close="false"
             :append-to-body="appendToBody">
    <div id="stockDetailBody">

      <div class="productHeader">
        <el-form :inline="true"
                 :model="formInline"
                 class="demo-form-inline">
          <el-row>
            <el-col :span="24">
              <el-radio-group v-model="formInline.typeFlag"
                              @change="changeTypeFlag"
                              class="type-flag"
                              size="medium">
                <el-radio-button :label="1">中类汇总</el-radio-button>
                <el-radio-button :label="2">小类汇总</el-radio-button>
              </el-radio-group>
              <el-button class="export"
                         @click="exportExcel"
                         v-if="formInline.showType==1"
                         size="small">导出</el-button>
              <el-radio-group v-model="formInline.showType"
                              @change="changeShowType"
                              class="type-show">
                <el-radio :label="0">图表展示</el-radio>
                <el-radio :label="1">报表展示</el-radio>
              </el-radio-group>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <!-- <el-row class="productBody"
              :class="{ 'showType': formInline.showType==1}"
              :gutter="20">
        <el-col :span="24"
                class="data-more"
                v-if="pageIndexImg!=0">
          <span @click="handlePrevImg">点击获取历史数据</span>
        </el-col>
        <el-col :span="6"
                v-for="(stock,index) in stockDetailListImg"
                :key="index">
          <p>{{stock.productTypeName}}</p>
          <div class="chart-img"
               :id="'myChartStockAccount'+index"
               :style="{width: '140px', height: '140px'}"></div>
          <div class="chart-txt">
            <div class="color-block1">
              <div>&nbsp;</div>
              <span>昨日剩货</span>
            </div>
            <div>￥{{stock.lastMoney2}}</div>
            <div>{{stock.lastMoneyPer}}%</div>
            <div class="color-block2">
              <div>&nbsp;</div>
              <span>今日到货</span>
            </div>
            <div>￥{{stock.inMoney2}}</div>
            <div>{{stock.inMoneyPer}}%</div>
          </div>
        </el-col>
        <el-col :span="24"
                class="data-more"
                id="more">
          <template v-if="(pageIndexImg+1)*pageSize>=totalCount">
            <span>没有更多数据了！</span>
          </template>
          <template v-else>
            <span @click="handleNextImg">点击加载更多...</span>
          </template>
        </el-col>
      </el-row> -->
      <div class="productBodys"
           id="productBodys"
           :class="{ 'showType': formInline.showType==1}">
        <happy-scroll size="6"
                      :scroll-top.sync="scrollTop"
                      @vertical-start="handlePrevImg"
                      @vertical-end="handleNextImg"
                      resize>
          <el-row :gutter="20">
            <el-col :span="24"
                    id="data-more-up"
                    class="data-more-up"
                    v-if="pageIndexImg!=0&&handle=='1'">
              <span @click="handlePrevImg">上滑获取更多数据</span>
            </el-col>
            <el-col :span="6"
                    v-for="(stock,index) in stockDetailListImg"
                    :key="index">
              <p>{{stock.productTypeName}}</p>
              <div class="chart-img"
                   :id="'myChartStockAccount'+index"
                   :style="{width: '140px', height: '140px'}"></div>
              <div class="chart-txt">
                <div class="color-block1">
                  <div>&nbsp;</div>
                  <span>昨日剩货</span>
                </div>
                <div>￥{{stock.lastMoney2}}</div>
                <div>{{stock.lastMoneyPer}}%</div>
                <div class="color-block2">
                  <div>&nbsp;</div>
                  <span>今日到货</span>
                </div>
                <div>￥{{stock.inMoney2}}</div>
                <div>{{stock.inMoneyPer}}%</div>
              </div>
            </el-col>
            <el-col :span="24"
                    class="data-more"
                    id="more"
                    v-if="(pageIndexImg+1)*pageSize>=totalCount">
              <span>没有更多数据了！</span>
            </el-col>
            <el-col :span="24"
                    id="data-more-down"
                    class="data-more-down"
                    v-else>
              <span>下滑取更多数据</span>
            </el-col>
          </el-row>
        </happy-scroll>
      </div>
      <div class="productBody"
           id="productBodys"
           :class="{ 'showType': formInline.showType==0}">
        <el-table id="stockAccountData"
                  class="table-common"
                  border
                  :data="stockDetailList"
                  style="width: 100%"
                  height="420"
                  :row-class-name="tableRowClassName"
                  @sort-change="sortChange">
          <el-table-column label-class-name="product-data-index"
                           type="index"
                           label
                           align="center"
                           fixed
                           width="50"></el-table-column>
          <el-table-column prop="deptName"
                           label="门店名称"
                           header-align="center"></el-table-column>
          <el-table-column prop="productTypeName"
                           :label="formInline.typeFlag===1?'中类':'小类'"
                           header-align="center"></el-table-column>
          <el-table-column prop="lastMoney2"
                           label="昨日剩货"
                           align="right"
                           sortable
                           header-align="right"></el-table-column>
          <el-table-column prop="lastMoneyPer"
                           label="昨日剩货百分比"
                           align="right"
                           header-align="center">
            <template slot-scope="scope">{{ scope.row.lastMoneyPer }}%</template>
          </el-table-column>
          <el-table-column prop="inMoney2"
                           label="今日到货"
                           align="right"
                           sortable
                           header-align="center"></el-table-column>
          <el-table-column prop="inMoneyPer"
                           label="今日到货百分比"
                           align="right"
                           header-align="center">
            <template slot-scope="scope">{{ scope.row.inMoneyPer }}%</template>
          </el-table-column>
          <el-table-column prop="nowLastMoney"
                           label="剩货"
                           sortable
                           align="right"
                           header-align="center">
            <template slot-scope="scope">{{ scope.row.nowLastMoney }}</template>
          </el-table-column>
        </el-table>
        <el-pagination background
                       @current-change="handleCurrentChange"
                       @prev-click="handlePrev"
                       @next-click="handleNext"
                       :current-page="pageIndex+1"
                       :page-size="pageSize"
                       layout="prev, pager, next"
                       :total="totalCount">
        </el-pagination>
      </div>
      <div slot="footer"
           class="dialog-footer">
        <el-button size="small"
                   @click="closeStockDA">关闭</el-button>

      </div>
    </div>
    <!-- 导出弹框 start -->
    <el-dialog class="exportDialog"
               :visible.sync="centerDialogVisible"
               width="30%"
               :close-on-click-modal="false"
               :close-on-press-escape="false"
               :show-close="false"
               append-to-body
               center>
      <el-progress class="exportProgress"
                   :text-inside="false"
                   :show-text="false"
                   :stroke-width="16"
                   :percentage="percentage"></el-progress>
      <p>{{percenttxt}}</p>
    </el-dialog>
    <!-- 导出弹框 end -->
    <el-dialog class="exportTip"
               title="导出范围"
               :visible.sync="exportDialogVisible"
               width="30%"
               append-to-body>
      <el-radio-group v-model="isExportAll">
        <el-radio :label="false">当前页</el-radio>
        <el-radio :label="true">全部</el-radio>
      </el-radio-group>
      <span slot="footer"
            class="dialog-footer">
        <el-button size="small"
                   @click="exportDialogVisible = false">取 消</el-button>
        <el-button type="primary"
                   size="small"
                   @click="handleExportData">确 定</el-button>
      </span>
    </el-dialog>
  </el-dialog>
</template>
<script>
import productApi from "@/api/api-product";
import stockApi from "@/api/api-stock";
import common from "@/libs/common";
import {
  localToken
} from '@/libs/util';
// 引入导出Excel表格依赖
import FileSaver from "file-saver";
import XLSX from "xlsx";
let loadingAccountStock
// let loadingMoreAccount
export default {
  props: {
    time: {
      type: String,
      default: ''
    },
    deptId: {
      type: String,
      default: ''
    },
    deptName: {
      type: String,
      default: ''
    },
    stockDADialogVisible: {
      type: Boolean,
      default: false
    },
    appendToBody: {
      type: Boolean,
      default: true
    },
    tHeader: {
      type: Array,
      default () {
        return []
      }
    },
    filterVal: {
      type: Array,
      default () {
        return []
      }
    }
  },
  data () {
    return {
      formInline: {
        time: '',
        typeFlag: 1,
        showType: 0
      },
      stockDetailListOld: [],
      stockDetailList: [],
      stockDetailListImg: [],
      tableDataStock: [],
      pageIndexImg: 0, // 图表展示页码
      pageIndex: 0, // 报表展示页面
      pageSize: 16,
      totalCount: 0,
      // 导出弹框
      centerDialogVisible: false,
      percentage: 0,
      percenttxt: "导出数据100条,已处理50条,正在导出,请稍等",
      order: "descending",
      prop: "nowLastMoney",
      exportData: [],
      isExportAll: false,
      exportDialogVisible: false,
      scrollTop: 5,
      handle: '0'
    }
  },

  methods: {
    //定义导出Excel表格事件
    exportExcel () {
      let that = this;
      if (that.stockDetailListOld.length == 0) {
        const h = that.$createElement;
        MessageBox({
          message: h("div", null, [
            h("i", {
              class: "el-icon-warning message-login-title"
            }),
            h("span", { class: "message-login-txt" }, " 提示"),
            h("p", { class: "message-login-content" }, "请先查找数据！ ")
          ]),
          showCancelButton: false,
          confirmButtonText: "确定",
          beforeClose: (action, instance, done) => {
            done();
          }
        });
        return;
      }
      that.exportDialogVisible = true
    },
    handleExportData () {
      let that = this
      let formInline = that.formInline
      let tHeader = []
      let filterVal = []
      tHeader = JSON.parse(JSON.stringify(that.tHeader)).map((item, index) => {
        if (index == 2) {
          if (formInline.typeFlag === 1) {
            return '中类'
          } else {
            return '小类'
          }
        } else {
          return item
        }
      })
      filterVal = JSON.parse(JSON.stringify(that.filterVal)).map(item => item)
      var dataExport = that.isExportAll ? that.exportData : that.stockDetailList;  //把要导出的数据tableData存到list
      that.centerDialogVisible = true;
      var iSpeed = 1;
      that.percentage = 0;
      that.percenttxt =
        "导出数据" + dataExport.length + "条，已处理0条，正在导出,请稍等";
      var obj = setInterval(function () {
        iSpeed += 6;
        if (iSpeed >= 100) {
          // 设置达到多少进度后停止
          that.percentage = 100;
          that.percenttxt = "导出数据" + dataExport.length + "条，已完成！";
          clearInterval(obj);
          setTimeout(() => {
            that.centerDialogVisible = false;
          }, 200);
        } else {
          that.percentage = iSpeed;
          that.percenttxt =
            "导出数据" +
            dataExport.length +
            "条，已处理" +
            parseInt(dataExport.length * (iSpeed / 100)) +
            "条，正在导出，请稍等";
        }
      }, 12); // 20毫秒后函数执行一次
      require.ensure([], () => {
        const { export_json_to_excel } = require('@/Excel/Export2Excel');//注意这个Export2Excel路径
        // let list = dataExport; // 把要导出的数据tableData存到list
        const data = localToken.formatJson(filterVal, dataExport);
        export_json_to_excel(tHeader, data, that.deptName + "剩余明细详情" + common.getDateDetail());//最后一个是表名字
      })
      that.exportDialogVisible = false
    },
    // //定义导出Excel表格事件
    // exportExcel () {
    //   let that = this;
    //   if (that.stockDetailList.length == 0) {
    //     const h = that.$createElement;
    //     MessageBox({
    //       message: h("div", null, [
    //         h("i", {
    //           class: "el-icon-warning message-login-title"
    //         }),
    //         h("span", { class: "message-login-txt" }, " 提示"),
    //         h("p", { class: "message-login-content" }, "请先查找数据！ ")
    //       ]),
    //       showCancelButton: false,
    //       confirmButtonText: "确定",
    //       beforeClose: (action, instance, done) => {
    //         done();
    //       }
    //     });
    //     return;
    //   }
    //   that.centerDialogVisible = true;
    //   var iSpeed = 1;
    //   that.percentage = 0;
    //   that.percenttxt =
    //     "导出数据" + that.stockDetailList.length + "条，已处理0条，正在导出,请稍等";
    //   var obj = setInterval(function () {
    //     iSpeed += 6;
    //     if (iSpeed >= 100) {
    //       // 设置达到多少进度后停止
    //       that.percentage = 100;
    //       that.percenttxt = "导出数据" + that.stockDetailList.length + "条，已完成！";
    //       clearInterval(obj);
    //       setTimeout(() => {
    //         that.centerDialogVisible = false;
    //       }, 200);
    //     } else {
    //       that.percentage = iSpeed;
    //       that.percenttxt =
    //         "导出数据" +
    //         that.stockDetailList.length +
    //         "条，已处理" +
    //         parseInt(that.stockDetailList.length * (iSpeed / 100)) +
    //         "条，正在导出，请稍等";
    //     }
    //   }, 12); // 20毫秒后函数执行一次
    //   var wb = XLSX.utils.table_to_book(document.querySelector("#stockAccountData"), {
    //     raw: true
    //   })
    //   //1、获取所有的键组成的字符串数组：
    //   let keys = Object.keys(wb.Sheets.Sheet1);
    //   //2、随机获取一个合法的下标
    //   var len = Math.ceil(keys.length / 2) - 1;
    //   var sheet1 = wb.Sheets.Sheet1;
    //   //3、显示键的名字和键对应的值
    //   for (var i = len; i < keys.length - 2; i++) {
    //     delete sheet1[keys[i]];
    //   }
    //   wb.Sheets.Sheet1 = sheet1;
    //   /* 获取二进制字符串作为输出 */
    //   var wbout = XLSX.write(wb, {
    //     bookType: "xlsx",
    //     bookSST: true,
    //     type: "array"
    //   });
    //   try {
    //     FileSaver.saveAs(
    //       //Blob 对象表示一个不可变、原始数据的类文件对象。
    //       //Blob 表示的不一定是JavaScript原生格式的数据。
    //       //File 接口基于Blob，继承了 blob 的功能并将其扩展使其支持用户系统上的文件。
    //       //返回一个新创建的 Blob 对象，其内容由参数中给定的数组串联组成。
    //       new Blob([wbout], { type: "application/octet-stream" }),
    //       //设置导出文件名称
    //       that.deptName + "剩余明细详情" + common.getDateDetail() + ".xlsx"
    //     );
    //   } catch (e) {
    //     if (typeof console !== "undefined") console.log(e, wbout);
    //   }
    //   return wbout;
    // },
    tableRowClassName ({ row, rowIndex }) {
      if (rowIndex % 2 === 0) {
      } else {
        return "success-row";
      }
      return "";
    },
    getStockDetail (data) {
      return new Promise((resolve, reject) => {
        stockApi
          .getStockDetail(data)
          .then(res => {
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    closeStockDA () {
      let that = this
      loadingAccountStock.close();
      that.$emit("close_stockDA", false)
    },
    // 上一页图表
    handlePrevImg () {
      let that = this
      // if (loadingMoreAccount) {
      //   that.$nextTick(() => {
      //     loadingMoreAccount.close();
      //   });
      // }
      // loadingMoreAccount = that.$loading({
      //   lock: true,
      //   spinner: "el-icon-loading",
      //   background: "rgba(255, 255, 255, 0.7)",
      //   target: document.querySelector("#data-more-up")
      // });
      if (that.pageIndexImg > 0) {
        that.pageIndexImg -= 1
        that.getDate()
        that.scrollTop = 400
        that.handle = '1'
      }
      // loadingMoreAccount.close();
    },
    // 下一页图表
    handleNextImg () {
      let that = this
      // if (loadingMoreAccount) {
      //   that.$nextTick(() => {
      //     loadingMoreAccount.close();
      //   });
      // }
      if ((that.pageIndexImg + 1) * that.pageSize >= that.totalCount) {
        return
      }
      // loadingMoreAccount = that.$loading({
      //   lock: true,
      //   spinner: "el-icon-loading",
      //   background: "rgba(255, 255, 255, 0.7)",
      //   target: document.querySelector("#data-more-down")
      // });
      that.pageIndexImg += 1
      that.getDate()
      that.scrollTop = 5
      // loadingMoreAccount.close();
    },
    // 当前页改变时触发
    handleCurrentChange (page) {
      let that = this
      that.pageIndex = page - 1
      that.getDate()
    },
    // 上一页按钮改变当前页后触发
    handlePrev (page) {
      let that = this
      that.pageIndex = page - 1
      that.getDate()
    },
    // 下一页按钮改变当前页后触发
    handleNext (page) {
      let that = this
      that.pageIndex = page - 1
      that.getDate()
    },
    // 排序
    sortChange (opt) {
      // alert(JSON.stringify(opt))
      this.order = opt.order
      this.prop = opt.prop
      this.getDate()
    },
    getDate () {
      let that = this
      let data = JSON.parse(JSON.stringify(that.stockDetailListOld))
      // 数组排序
      if (that.order && that.prop) {
        data.sort(localToken.compare(that.prop))
        if (that.order !== 'ascending') {
          data.reverse()
        }
      }
      that.exportData = data.map((item, index) => {
        item["index"] = index + 1
        return item
      })
      let showType = that.formInline.showType // 0图标 1报表
      let pageIndex = 0
      let pageSize = that.pageSize
      if (showType == 0) {
        pageIndex = that.pageIndexImg
        let i = 0
        that.stockDetailListImg = data.filter((item, index) => {
          if (index >= pageIndex * pageSize - 4 && index < (pageIndex + 1) * pageSize) {
            i++
            item["index"] = i
            return item
          }
        })
        setTimeout(() => {
          that.drawLineStock()
          // if (loadingMoreAccount) { loadingMoreAccount.close(); }
        }, 200);
      } else {
        pageIndex = that.pageIndex
        let i = 0
        that.stockDetailList = data.filter((item, index) => {
          if (index >= pageIndex * pageSize && index < (pageIndex + 1) * pageSize) {
            i++
            item["index"] = i
            return item
          }
        })
      }
    },
    // 切换汇总方式
    changeTypeFlag () {
      this.getStock()
    },
    // 切换展示方式
    changeShowType () {
      this.getDate()
    },
    // 绘制图表
    drawLineStock () {
      let that = this;
      let data = that.stockDetailListImg
      data.map((item, index) => {
        // 基于准备好的dom，初始化echarts实例
        let myChart = that.$echarts.init(document.getElementById("myChartStockAccount" + index));
        // 绘制图表
        myChart.setOption({
          tooltip: {
            trigger: "item",
            formatter: "{a} <br/>{b}: {c} ({d}%)"
          },
          color: ["#f1bc4c", "#4c9aef"],
          series: [
            {
              name: "访问来源",
              type: "pie",
              radius: ["45%", "80%"],
              center: ["50%", "50%"],
              avoidLabelOverlap: false,
              label: {
                normal: {
                  show: false,
                  position: "center"
                },
                emphasis: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: "rgba(255, 255, 255, 0.2)",
                  textColor: "#000"
                }
              },
              labelLine: {
                normal: {
                  show: false
                }
              },
              data: [
                { value: item.lastMoney2, name: "昨日剩货" },
                {
                  value: item.inMoney2,
                  name: "今日到货"
                }
              ]
            },
            // 边框的设置
            {
              radius: ["70%", "80%"],
              center: ["50%", "50%"],
              type: "pie",
              label: {
                normal: {
                  show: false
                },
                emphasis: {
                  show: false
                }
              },
              labelLine: {
                normal: {
                  show: false
                },
                emphasis: {
                  show: false
                }
              },
              animation: false,
              tooltip: {
                show: false
              },
              itemStyle: {
                normal: {
                  color: "rgba(250,250,250,0.2)"
                }
              },
              data: [
                {
                  value: 1
                }
              ]
            }
          ]
        });
      })

    },

    // 根据中类小类获取商品分类列表
    // TypeFlag 0小类 1中类
    // TypeId 中类id,查询中类下小类列表(可不传)
    getProductTypeListByFLag (data) {
      return new Promise((resolve, reject) => {
        productApi
          .getProductTypeListByFLag(data)
          .then(res => {
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    getStock () {
      let that = this
      if (loadingAccountStock) {
        that.$nextTick(() => {
          loadingAccountStock.close();
        });
      }
      loadingAccountStock = that.$loading({
        lock: true,
        text: "拼命加载中",
        spinner: "el-icon-loading",
        background: "rgba(255, 255, 255, 0.7)",
        target: document.querySelector("#productBodys")
      });

      // 初始化页码
      that.pageIndex = 0
      that.pageIndexImg = -1
      that.totalCount = 0
      let formInline = that.formInline
      let data = {
        "searchDate": formInline.time,
        "areaId": [],
        "deptId": [that.deptId],
        "productTypeId": []
      }
      if (formInline.typeFlag === 2) {
        //按门店、小类汇总
        data["typeFlag"] = 0
      } else {
        // 中类汇总
        data["typeFlag"] = 1
      }
      that.getStockDetail(data).then(res => {
        that.stockDetailListOld = res.map((item, index) => {
          item["index"] = index + 1
          item["inMoney2"] = Math.round(item.inMoney * 100) / 100; // 今日到货
          item["lastMoney2"] = Math.round(item.lastMoney * 100) / 100; // 昨日剩货
          item["totalMoney2"] =
            Math.round((item.inMoney + item.lastMoney) * 100) / 100; // 今日总货量
          item["inMoneyPer"] =
            Math.round(
              (item["totalMoney2"] ? (item["inMoney2"] / item["totalMoney2"]) * 100 : 100) *
              100
            ) / 100; // 今日到货占比
          item["lastMoneyPer"] = Math.round((100 - item.inMoneyPer) * 100) / 100; // 昨日剩货占比
          item["nowLastMoney"] =
            Math.round((item.inMoney + item.lastMoney - item.outMoney) * 100) /
            100; // 剩货
          item["nowLastMoneyPer"] =
            Math.round(
              (item["totalMoney2"]
                ? (item["nowLastMoney"] / item["totalMoney2"]) * 100
                : 100) * 100
            ) / 100; // 剩货占比
          return item
        })
        that.totalCount = that.stockDetailListOld.length
        that.getDate()
        loadingAccountStock.close();
      }, err => {
        loadingAccountStock.close();
        console.log(err)
      })
    },
    init () {
      let that = this
      that.$set(that.formInline, 'time', that.time)
      that.$set(that.formInline, 'typeFlag', 1)
      that.$set(that.formInline, 'showType', 0) // 0图表展示 2报表展示
      that.order = "descending"
      that.prop = "nowLastMoney"
      that.getStock()
    }
  },
  watch: {
    // 路由变化
    stockDADialogVisible (val) {
      if (val) {
        this.init()
      } else {
        if (loadingAccountStock) {
          this.$nextTick(() => {
            loadingAccountStock.close();
          });
        }
        // if (loadingMoreAccount) {
        //   this.$nextTick(() => {
        //     loadingMoreAccount.close();
        //   });
        // }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/view/main/stockDetailAccount.vue